import { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import MobileStepper from '@mui/material/MobileStepper';
import * as yup from 'yup';
import { ButtonRow, FormCheckBox, FormStepper, useTrackedFormik } from '@omnigenbiodata/ui';

import InnerLayout from '../../../../layout/Inner';
import ROUTES from '../../../../core/constants/routes.constant';
import { ENROLMENT_STEPS, MESSAGES, TOTAL_CONSENT_STEPS } from '../../../../core/constants/forms.constant';
import { stepForward } from '../../../../store/enrolment';
import { useAppDispatch } from '../../../../store';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

const validationSchema = yup.object({
  consent1: yup.boolean().oneOf([true], MESSAGES.consentRequired),
});

function Consent1() {
  const { t } = useTranslation('consent');
  const dispatch = useAppDispatch();
  const navigateTo = useNavigate();
  const formik = useTrackedFormik(
    {
      initialValues: { consent1: false },
      validationSchema: validationSchema,
      onSubmit: (values) => {
        dispatch(stepForward(values));
        navigateTo(ROUTES.enrolmentConsent2);
      },
    },
    'enrol-consent1',
  );

  const handleSubmit = (event: FormEvent) => {
    formik.handleSubmit();
    event.preventDefault();
  };

  return (
    <InnerLayout>
      <form onSubmit={handleSubmit}>
        <Box my={3}>
          <FormStepper steps={ENROLMENT_STEPS} activeStep={1} />
        </Box>
        <Box mb={8}>
          <Paper elevation={5}>
            <Box p={3}>
              <Typography variant="h4" component="h1" align="center" gutterBottom>
                1. {t('section1.title')}
              </Typography>
              <MobileStepper
                backButton={false}
                nextButton={false}
                variant="dots"
                steps={TOTAL_CONSENT_STEPS}
                position="static"
                activeStep={0}
              />
              <Typography variant="body1" component="span" align="left">
                <ReactMarkdown>{t('section1.body')}</ReactMarkdown>
              </Typography>
              <FormCheckBox
                error={formik.errors.consent1}
                name="consent1"
                label={t('confirmation')}
                onChange={formik.handleChange}
                touched={formik.touched.consent1}
                value={formik.values.consent1}
              />
            </Box>
          </Paper>
        </Box>
        <ButtonRow buttonSize="large" forwardColor="primary" />
      </form>
    </InnerLayout>
  );
}

export default Consent1;
